import styles from './UnlockedButton.module.scss';
import lockIcon from '../../images/lock-icon.png';

interface Props {
  small?: boolean;
  disabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const UnlockedButton = ({ small, disabled, ...otherProps }: Props) => (
  <div className={styles.cardUnlocked}>
    <button type='button' disabled={disabled} {...otherProps} className={styles.cardUnlocked}>
      <img src={lockIcon} alt='lock icon' className={styles.lockIcon} />
    </button>
  </div>
);

export default UnlockedButton;
